<div class="card-details-container">
  <lib-meter-validation-card
    [title]="'METERS.PLURAL'"
    [number]="totalCount"
    [lastMonthCount]="123"
    [iconKey]="'meters'"
  />
  <lib-meter-validation-card
    [title]="'COMMON.VALIDATED_METERS'"
    [number]="totalValidatedCount"
    [iconKey]="'validated-meters'"
  />
  <lib-meter-validation-card
    [title]="'COMMON.VALIDATION_RATE'"
    [number]="validationPercentage"
    [iconKey]="'validation-rate'"
    [isPercentageNumber]="true"
  />
</div>
<p *ngIf="meterValidationRegionData.length" class="header-title">
  {{ "COMMON.SUMMARY_BREAKDOWN_BY" | translate }}
  {{ "COMMON.BU.SINGLE" | translate }}
</p>
<div class="card-container">
  <lib-meter-validation-card
    *ngFor="let item of meterValidationRegionData"
    [title]="item.regionName"
    [number]="item.validatedCount"
    [useDetails]="true"
    [seeBreakdownVisible]="true"
    [percentage]="
      item.validatedCount ? (item.validatedCount / item.totalCount) * 100 : 0
    "
    [meterValidationRegionData]="item"
    (detailsClicked)="openDetailsModal($event)"
  >
  </lib-meter-validation-card>
</div>

<div
  class="modal fade modal-right"
  id="regionBreakdownModal"
  #detailsModal
  tabindex="-1"
  role="dialog"
  aria-labelledby="regionBreakdownModalTitle"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-right" role="document">
    <div class="modal-content modal-map-details">
      <div>
        <div class="summary-header">
          <div class="summary-title">
            {{ selectedRegionData?.regionName }}
          </div>
          <button type="button" class="modal-close" data-bs-dismiss="modal" aria-label="Close">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12ZM9.53033 8.46967C9.23744 8.17678 8.76256 8.17678 8.46967 8.46967C8.17678 8.76256 8.17678 9.23744 8.46967 9.53033L10.9393 12L8.46967 14.4697C8.17678 14.7626 8.17678 15.2374 8.46967 15.5303C8.76256 15.8232 9.23744 15.8232 9.53033 15.5303L12 13.0607L14.4697 15.5303C14.7626 15.8232 15.2374 15.8232 15.5303 15.5303C15.8232 15.2374 15.8232 14.7626 15.5303 14.4697L13.0607 12L15.5303 9.53033C15.8232 9.23744 15.8232 8.76256 15.5303 8.46967C15.2374 8.17678 14.7626 8.17678 14.4697 8.46967L12 10.9393L9.53033 8.46967Z" fill="#171717"/>
            </svg>
          </button>

        </div>
          <div class="modal-header map-header">
            <div class="map-container">
            <div class="region-info">
              <div class="region-icon">
                <div class="region-bubble">
                  <div class="region-bu">
                    {{'COMMON.BU.FULL_NAME' | translate}}
                  </div>
                  <div class="region-name">
                    {{ selectedRegionData?.regionName }}
                  </div>
                </div>
                <svg width="16" height="20" viewBox="0 0 16 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8C16 10.7518 14.648 13.2958 13.1522 15.2808C11.647 17.2783 9.9278 18.7997 9.0481 19.5217C8.4341 20.0257 7.5659 20.0257 6.9519 19.5217C6.0722 18.7997 4.35301 17.2783 2.84776 15.2808C1.35195 13.2958 0 10.7518 0 8ZM4.875 8C4.875 6.27411 6.2741 4.875 8 4.875C9.7259 4.875 11.125 6.27411 11.125 8C11.125 9.7259 9.7259 11.125 8 11.125C6.2741 11.125 4.875 9.7259 4.875 8Z" fill="white"/>
                </svg>
              </div>
            </div>
            <google-map
              *ngIf="mapReady"
              [center]="center"
              [options]="mapOptions">
            </google-map>
                <div class="map-gradient-overlay">
                </div>

            </div>
        </div>
            
        <div class="subtitle">{{ "COMMON.UNDERTAKINGS" | translate }}</div>

        <div class="area-list" *ngIf="selectedRegionData?.meterValidationPerArea?.length">
          <div class="area-row" *ngFor="let area of selectedRegionData?.meterValidationPerArea">
            <div class="area-name">{{ area.areaName }}</div>
            <div class="area-stats">
            <span class="counts"><span class="counts-strong">{{ area.validatedCount }}/</span>{{ area.totalCount }}</span>
              <div class="card-delta-container">        
                <span class="centered-icon-text">
                {{ (area.totalCount ? (area.validatedCount / area.totalCount) * 100 : 0) | number:'1.2-2' }}%
                <svg width="20" height="19" viewBox="0 0 20 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect x="0.0761719" y="0.869995" width="19.6742" height="18.13" rx="4" fill="#00A372"/>
                  <path d="M6.07617 8.70712L9.91329 4.87L13.7504 8.70712M9.91329 15V5.33045" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
               </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <hr />

      <button type="button" class="transparent-button" data-bs-dismiss="modal">
        {{ "COMMON.CLOSE" | translate }}
      </button>
    </div>
  </div>
</div>
